import React, { Component } from 'react'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import AddendumSignUI from './AddendumSignUI.js'

class AddendumSignSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addendumUploadMode: false,
      addendumUploadSuccessMsg: null,
      addendumUploadErrorList: null,
      addendumUploadSubmitted: false,
      //
      selectedAddendumId: null,
      //
      addendumSubmitted: false,
      addendumErrorList: null,
      addendumSuccessMsg: null,
      //
      downloadRequested: false,
      downloadErrorList: null,
    }
  }

  render() {
    return (
      <AddendumSignUI
        context={this.props.context}
        loan={this.props.loan}
        onRefreshClick={this.props.onRefreshClick}
        //
        addendumUploadMode={this.state.addendumUploadMode}
        onAddendumUpload={this.onAddendumUpload}
        onAddendumUploadClick={this.onAddendumUploadClick}
        onCancelAddendumUpload={() => { this.setState({ addendumUploadMode: false }) }}
        addendumUploadSuccessMsg={this.state.addendumUploadSuccessMsg}
        addendumUploadErrorList={this.state.addendumUploadErrorList}
        addendumUploadSubmitted={this.state.addendumUploadSubmitted}
        //
        selectedAddendumId={this.state.selectedAddendumId}
        //
        onAddendumSubmit={this.onAddendumSubmit}
        addendumSubmitted={this.state.addendumSubmitted}
        addendumErrorList={this.state.addendumErrorList}
        addendumSuccessMsg={this.state.addendumSuccessMsg}
        //
        onAddendumDownloadClick={this.onAddendumDownloadClick}
        downloadRequested={this.state.downloadRequested}
        downloadErrorList={this.state.downloadErrorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onAddendumUploadClick = (event) => {
    let addendumId = event.currentTarget.getAttribute('data-row-id')
    this.setState({ addendumUploadMode: true, selectedAddendumId: addendumId })
  }

  onAddendumUpload = () => {
    this.setState({
      addendumUploadSubmitted: true,
      addendumUploadSuccessMsg: null,
      addendumUploadErrorList: [],
    })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/addendum/${this.state.selectedAddendumId}/pdfDocuments/validation`,
      this.onAddendumUploadCallback, {}
    )
  }

  onAddendumUploadCallback = (response) => {
    this.setState({ addendumUploadSubmitted: false })

    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      addendumUploadErrorList: errorList,
      addendumUploadSuccessMsg: response.success
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          addendumUploadSuccessMsg: null,
        })
      }, 5000)
    }
  }

  onAddendumSubmit = (event) => {
    let addendumId = event.currentTarget.getAttribute('data-row-id')

    let submitted = this.state.addendumSubmitted
    if (submitted)
      return

    this.setState({
      addendumSuccessMsg: null,
      addendumErrorList: [],
      addendumSubmitted: true,
      selectedAddendumId: addendumId
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/addendum/${addendumId}/esign`,
      this.onAddendumSubmitCallback, {}
    )
  }

  onAddendumSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      addendumSuccessMsg: response.success,
      addendumErrorList: errorList,
      addendumSubmitted: false,
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          addendumSuccessMsg: null,
        })
        this.props.onRefreshClick('noBusy')
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ addendumErrorList: [] })
      }, 5000)
    }
  }

  onAddendumDownloadClick = (event) => {
    let addendumId = event.currentTarget.getAttribute('data-row-id')
    this.setState({ downloadRequested: true, selectedAddendumId: addendumId })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/addendum/${addendumId}/fileDownloadSignedUrl`,
      this.onAddendumDownloadClickCallback, null, null
    )
  }

  onAddendumDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export default AddendumSignSF
